/* Progressive enhancement. Native Shopify forms remain the fallback. */
(() => {
  'use strict';
  const routesNode = document.getElementById('StoreRoutes');
  if (!routesNode) return;
  const routes = JSON.parse(routesNode.textContent);
  const status = document.getElementById('StoreStatus');
  const cartDialog = document.getElementById('CartDialog');
  const formatMoney = (cents, currency = routes.currency) => new Intl.NumberFormat(currency === 'PKR' ? 'en-PK' : routes.locale, {style:'currency', currency}).format(cents / 100);
  const say = message => { if (status) status.textContent = message; };
  const make = (tag, className, value) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (value !== undefined) node.textContent = value;
    return node;
  };
  const safeStoreUrl = value => {
    try { const url = new URL(value, window.location.origin); return url.origin === window.location.origin ? url.href : routes.cart; }
    catch { return routes.cart; }
  };
  const openDialog = dialog => {
    if (!dialog || !dialog.showModal) return false;
    document.querySelectorAll('dialog[open]').forEach(other => { if (other !== dialog) other.close(); });
    if (!dialog.open) dialog.showModal();
    return true;
  };
  const request = async (url, options = {}) => {
    const response = await fetch(url, {credentials:'same-origin', ...options});
    let result;
    try { result = await response.json(); } catch { throw new Error('We couldn’t update your bag. Please try again.'); }
    if (!response.ok) throw new Error(result.description || result.message || 'We couldn’t update your bag. Please try again.');
    return result;
  };
  const updateCount = count => document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = count; });
  const drawCart = cart => {
    updateCount(cart.item_count);
    const target = cartDialog.querySelector('[data-cart-items]');
    target.replaceChildren();
    if (!cart.items.length) {
      const empty = make('div','drawer-empty');
      empty.append(make('h3','', 'Room for a new favourite.'), make('p','', 'Your bag is empty. Your next outfit is waiting.'));
      const explore = make('a','', 'Explore the edit');
      explore.href = routes.cart.replace(/cart\/?$/, 'collections/all');
      empty.append(explore); target.append(empty);
    }
    cart.items.forEach(item => {
      const line = make('div','drawer-line');
      if (item.image) {
        const imageLink = make('a'); imageLink.href = safeStoreUrl(item.url);
        const image = make('img'); image.src = item.image; image.alt = item.product_title; image.width = 80; image.height = 106; image.loading = 'lazy';
        imageLink.append(image); line.append(imageLink);
      }
      const content = make('div');
      const title = make('a','', item.product_title); title.href = safeStoreUrl(item.url); content.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') content.append(make('p','',item.variant_title));
      if (item.selling_plan_allocation) content.append(make('p','', item.selling_plan_allocation.selling_plan.name));
      content.append(make('p','', formatMoney(item.final_line_price, cart.currency)));
      const controls = make('div','drawer-line__controls');
      [['−', item.quantity - 1, 'Decrease quantity'], ['+', item.quantity + 1, 'Increase quantity']].forEach(([label, quantity, aria], index) => {
        if (index === 1) controls.append(make('span','',item.quantity));
        const button = make('button','',label); button.type='button'; button.dataset.cartKey=item.key; button.dataset.cartQuantity=quantity;
        button.setAttribute('aria-label', `${aria} for ${item.product_title}`); controls.append(button);
      });
      const remove = make('button','drawer-remove','Remove'); remove.type='button'; remove.dataset.cartKey=item.key; remove.dataset.cartQuantity='0';
      remove.setAttribute('aria-label', `Remove ${item.product_title}`); controls.append(remove); content.append(controls); line.append(content); target.append(line);
    });
    cartDialog.querySelector('[data-cart-total]').textContent = formatMoney(cart.total_price, cart.currency);
    cartDialog.querySelector('[data-cart-error]').textContent = '';
  };
  const refreshCart = async () => { const cart = await request(routes.cart + '.js'); drawCart(cart); return cart; };
  const showCart = async () => {
    if (!openDialog(cartDialog)) { window.location.href = routes.cart; return; }
    const error = cartDialog.querySelector('[data-cart-error]'); error.textContent = '';
    try { await refreshCart(); } catch (e) { error.textContent = e.message + ' You can also open the bag page below.'; }
  };
  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-open-dialog]');
    if (opener) {
      if (openDialog(document.getElementById(opener.dataset.openDialog))) event.preventDefault();
      return;
    }
    const closer = event.target.closest('[data-close-dialog]');
    if (closer) { closer.closest('dialog')?.close(); return; }
    const bag = event.target.closest('[data-open-cart]');
    if (bag && document.body.dataset.cartDrawer === 'true' && cartDialog?.showModal) { event.preventDefault(); await showCart(); return; }
    const change = event.target.closest('[data-cart-key]');
    if (change) {
      event.preventDefault();
      const requestedIndex = Array.from(cartDialog.querySelectorAll('[data-cart-key]')).indexOf(change);
      cartDialog.querySelectorAll('[data-cart-key]').forEach(button => { button.disabled = true; });
      try {
        const cart = await request(routes.change + '.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:change.dataset.cartKey,quantity:Number(change.dataset.cartQuantity)})});
        drawCart(cart); say('Your bag has been updated.');
        const updated = cartDialog.querySelectorAll('[data-cart-key]');
        (updated[Math.min(requestedIndex,updated.length-1)] || cartDialog.querySelector('[data-close-dialog]')).focus();
      } catch (e) {
        cartDialog.querySelector('[data-cart-error]').textContent=e.message;
        cartDialog.querySelectorAll('[data-cart-key]').forEach(button => { button.disabled = false; });
      }
    }
  });
  document.addEventListener('click', event => {
    if (event.target instanceof HTMLDialogElement && event.target.open) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  function initProducts(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return; section.dataset.initialized='true';
      const form = section.querySelector('[data-product-form]');
      const select = section.querySelector('[data-variant-select]');
      const button = section.querySelector('[data-add-button]');
      const label = section.querySelector('[data-add-label]');
      const qty = form?.querySelector('[name="quantity"]');
      if (!form || !select || !button) return;
      const variants = JSON.parse(section.querySelector('[data-product-variants]').textContent);
      const sync = (updateHistory = false) => {
        const option = select.options[select.selectedIndex];
        const variant = variants.find(v => String(v.id) === select.value);
        const available = option?.dataset.available === 'true';
        button.disabled = !available; label.textContent = available ? 'Add to bag' : 'Sold out';
        section.querySelector('[data-product-price]').textContent = option.dataset.price;
        const compare = section.querySelector('[data-product-compare]'); compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare;
        section.querySelectorAll('[name="variant-choice"]').forEach(input => { input.checked = input.value === select.value; });
        if (qty && variant?.quantity_rule) {
          const rule = variant.quantity_rule; qty.min=rule.min || 1; qty.step=rule.increment || 1;
          if (rule.max) qty.max=rule.max; else qty.removeAttribute('max');
          qty.value=rule.min || 1;
        }
        if (updateHistory) {
          const url = new URL(window.location.href); url.searchParams.set('variant',select.value); window.history.replaceState({},'',url);
          if (option.dataset.media) section.querySelector(`[data-media-id="${option.dataset.media}"]`)?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
        }
        section.querySelector('[data-product-error]').textContent='';
      };
      select.addEventListener('change',() => sync(true));
      section.querySelectorAll('[name="variant-choice"]').forEach(input => input.addEventListener('change',() => {select.value=input.value;sync(true);}));
      form.addEventListener('submit', async event => {
        if (document.body.dataset.cartDrawer !== 'true' || !cartDialog?.showModal) return;
        event.preventDefault();
        if (button.disabled) return;
        button.disabled=true;label.textContent='Adding…';
        try {
          const formData = new FormData(form); formData.delete('variant-choice');
          await request(routes.add + '.js',{method:'POST',body:formData});
          say('Added to your bag.'); await showCart();
        } catch (e) { section.querySelector('[data-product-error]').textContent=e.message; }
        finally { const option=select.options[select.selectedIndex];button.disabled=option.dataset.available!=='true';label.textContent=button.disabled?'Sold out':'Add to bag'; }
      });
      sync();
    });
  }
  initProducts();
  document.querySelectorAll('[data-country-select]').forEach(select => { if (select.dataset.default) select.value = select.dataset.default; });
  document.addEventListener('shopify:section:load',event => initProducts(event.target));
  window.addEventListener('pageshow',event => {if(event.persisted)request(routes.cart+'.js').then(cart=>updateCount(cart.item_count)).catch(()=>{});});
})();
